import React from "react";
import MobileEducationEntry from "./contentCards/mobileEducationEntry";
import { educations } from "../../data";

const MobileEducation = () => {
  return (
    <div className="text-white">
      <div
        style={{
          fontSize: "3em",
          fontWeight: "300",
          lineHeight: "1.25",
        }}
        className="mb-4"
      >
        Education & Training
      </div>
      {educations.map((edu) => (
        <MobileEducationEntry key={edu.id} education={edu} />
      ))}
    </div>
  );
};

export default MobileEducation;
